module.exports = __webpack_public_path__ + "static/media/naka-itabashi-4.94db11bd.jpg";